// eslint-disable-next-line eslint-comments/disable-enable-pair

/* eslint-disable line-comment-position */
import deepmerge from 'deepmerge'; // TODO: Once we switch to the new font definitions, see if we can set the font family at the root and remove all the redundant definitions everywhere
// TODO: See if we can define lineHeight once and have that cascade throughout

var family = 'jpmuitk-sans'; // TODO: Rename to weights?

var weight = {
  light: 200,
  regular: 400,
  semiBold: 600,
  bold: 700,
  extraBold: 800
}; // Type size ramp is defined here: https://jpm-ui-toolkit.test.gaiacloud.jpmchase.net/documentation/typography

var size = {
  '10': 8,
  // TODO: This isn't in the ramp. Validate that it's used
  '20': 9,
  // TODO: This isn't in the ramp. Validate that it's used
  '30': 10,
  '40': 11,
  // TODO: This isn't in the ramp. Validate that it's used
  '50': 12,
  '60': 14,
  '70': 16,
  '80': 18,
  '90': 20,
  // TODO: This isn't in the ramp. Validate that it's used
  '100': 22,
  '110': 24,
  // TODO: This isn't in the ramp. Validate that it's used
  '120': 26,
  // TODO: This isn't in the ramp. Validate that it's used
  '130': 30,
  '140': 32,
  // TODO: This isn't in the ramp. Validate that it's used
  '150': 36,
  // TODO: This isn't in the ramp. Validate that it's used
  '160': 38,
  // TODO: 38 is in the ramp but unused. Determine what should happen
  '170': 40,
  // TODO: This isn't in the ramp. Validate that it's used
  '180': 44,
  '190': 48,
  // TODO: This isn't in the ramp. Validate that it's used
  '200': 50,
  // TODO: This isn't in the ramp. Validate that it's used
  '210': 56,
  '220': 58,
  // TODO: This isn't in the ramp. Validate that it's used
  '230': 60,
  // TODO: This isn't in the ramp. Validate that it's used
  '240': 64,
  '250': 68 // TODO: This isn't in the ramp. Validate that it's used

};
var lineHeight = 1.3;

var getFace = function getFace() {
  var weightVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'regular';
  return {
    fontFamily: family,
    fontWeight: weight[weightVal]
  };
};

var roundToEvenNumber = function roundToEvenNumber(value) {
  return 2 * Math.round(value / 2);
};

var getMinHeight = function getMinHeight(fontSize) {
  return roundToEvenNumber(fontSize * lineHeight);
};

export var createTypography = function createTypography() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return deepmerge({
    family: family,
    weight: weight,
    size: size,
    lineHeight: lineHeight,
    getFace: getFace,
    getMinHeight: getMinHeight
  }, typeof overrides === 'function' ? overrides() : overrides, {
    clone: false
  });
};